var url = 'http://localhost:5000'

if(window.location.href.indexOf('http://localhost') == -1) {
    url = 'https://api.hyperobjects.design'
}

export const apiUrl = url